import { useState } from 'react';
import { Auth } from 'firebase/auth';
import { Toast } from 'react-bootstrap';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { ReactComponent as SignOutLogo } from '../assets/icons/Log Out-WF.svg';
import { ReactComponent as SignInLogo } from '../assets/icons/Login-01.svg';
import { ReactComponent as SignUpLogo } from '../assets/icons/Sign-Up-01.svg';
import { ReactComponent as ChangePassword } from '../assets/icons/Password-03-WF.svg';
import { ReactComponent as ImageSample } from '../../public/images/svg/ImageSample.svg';
import { ReactComponent as ImageLibrary } from '../../public/images/svg/Library-Books.svg';
import { AccountProfile } from './AccountProfile';
import { AccountChangePassword } from './AccountChangePassword';
import { ModalButton } from '../Controls/Button/ModalButton';
import { GlyphButton } from '../Controls/Button/GlyphButton';
import { ReactComponent as Settings } from '../../public/images/svg/skitterbook-settings.svg';
import { AccountSignIn } from './AccountSignIn';
import './css/AccountDetail.css';

interface AccountDetailProps {
    auth: Auth;
}

export const AccountDetail: React.FC<AccountDetailProps> = ({ auth }) => {

    const [toastMessage, setToastMessage] = useState<string | null>(null);
    const [changePasswordClose, setChangePasswordClose] = useState(0);

    return (
        <div className="account-detail-container">
            <div className="account-navigation-container">
                {auth.currentUser ? (
                    <div className="signed-in">
                        <GlyphButton ariaLabel="sign-out"
                            className="component-button"
                            label="Sign Out"
                            IconComponent={<SignOutLogo width={32} height={22.439} viewBox="0 0 32 22.439" />}
                            onClick={
                                () => {
                                    signOut(auth);
                                    setToastMessage(`You have successfully signed out, but your Skitterbooks stay safe.`)
                                }
                            } />
                        <ModalButton
                            className="account-change-password-modal component-button"
                            modalTitle="Change Password"
                            Title="Change Password"
                            externalCloseSignal={changePasswordClose}
                            IconComponent={<ChangePassword width={32} height={22.439} viewBox="0 0 32 22.439" />}>
                            <AccountChangePassword auth={auth} onSuccess={(res) => {
                                if (res) {
                                    setChangePasswordClose(Date.now());
                                    setToastMessage("You have successfully changed your password")
                                }
                            }} />
                        </ModalButton>
                    </div>
                ) : (
                    <div className="signed-out">
                        <ModalButton modalTitle="Sign In"
                            className="component-button"
                            Title="Sign In"
                            IconComponent={<SignInLogo width={32} height={32} viewBox="0 0 32 32" />}>
                            <AccountSignIn onSuccess={() => { }} />
                        </ModalButton>
                        <GlyphButton ariaLabel="sign-up"
                            className="component-button"
                            label="Create your Account"
                            IconComponent={<SignUpLogo width={32} height={29.4} viewBox="0 0 32 29.4" />}
                            onClick={() => { }} />
                    </div>
                )}
            </div>
            <div className="account-profile-container">
                <AccountProfile onSuccess={() => { }} />
            </div>
            <div className="account-content-container">
                <div className="example-content">
                    <div className="view-all-content-container">
                        <GlyphButton ariaLabel="view-all-content" className="component-button" label="View All Example Content"
                            IconComponent={<ImageSample width={32} height={32} viewBox="0 0 32 32" />} />                        
                    </div>
                    <div className="library-item-list-container pretty-scroll light">
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                    </div>
                </div>
                <div className="library-content">
                    <div className="view-all-content-container">
                        <GlyphButton ariaLabel="view-all-content" className="component-button" label="View Your Library Content"
                            IconComponent={<ImageLibrary width={32} height={32} viewBox="0 0 32 32" />} />
                    </div>
                    <div className="library-item-list-container pretty-scroll light">
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                        <div className="library-item"></div>
                    </div>
                </div>
            </div>
            <div className="account-settings-container">
                <ModalButton modalTitle="Settings" className="component-button" IconComponent={<Settings width={32} height={32} viewBox="0 0 32 32" />} >
                    <div className="account-settings-container"></div>
                </ModalButton>

            </div>

            <div className="skitter-toast-wrapper">
                <Toast
                    onClose={() => setToastMessage(null)}
                    show={!!toastMessage}
                    delay={4000}
                    autohide>
                    <Toast.Header>
                        <strong className="me-auto">Skitterbook</strong>
                    </Toast.Header>
                    <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
            </div>
        </div>
    );
};
